const Spinner = ( { isLoading = false }: {isLoading: boolean} ) => {
    return(
        <div id="dokan-spinner-overlay" style={{display: isLoading ? 'block' : 'none'}}>
            <div className="dokan-spinner-wrapper">
                <span className="dokan-loading-spinner"></span>
            </div>
        </div>
    );
}

export default Spinner;
